import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import errorCheck from 'images/icon_tick.svg';
import classNames from 'classnames';
import Image from 'components/Image';

const ValidationMessage = ({ validation }) => {
  const validationIcon = property => {
    return classNames({
      [styles.validationIcon]: true,
      [styles.hideIcon]: !property,
    });
  };

  return (
    <div className={styles.validationMsg}>
      <Image
        alt="upper-case"
        src={errorCheck}
        className={validationIcon(validation.value)}
      />
      <span>{validation.message}</span>
    </div>
  );
};

ValidationMessage.propTypes = {
  validation: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.bool,
    message: PropTypes.string,
  }),
};

export default ValidationMessage;
